<template>
  <div class="bordered">

    <div class="container-fill" @click="toggle">
      <div>
        <b>{{ change.title }}</b>
      </div>              
        {{ change.created.substring(0,10) }} {{ change.created.substring(11,19) }}     
    </div>   
      
    <pre class="debug" v-show="debugMode">{{change}}</pre>
    
  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#profileButtons {
  display: inline-block;
  float: right;
}
.default {
  font-size: small;
}
.container {
  display: flex;
}
.container-fill {
  display: flex;
  justify-content: space-between;
}
.details {
  margin-top: 5px;
  border-top: 1px solid #cccccc;
  padding-top: 5px;
}
.details-header {
  font-size: small;
}
.details-header > h2,h3,h4 {
  font-size: initial;
  margin: 0px;
}
</style>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    change: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState([
      'debugMode'
    ])
  },
  data () {
    
    return {             
          isActive: false
          //tempState: this.asset.state 
          //profileName: this.profile.name      
        }      
    
  },  
  methods: {
    toggle: function (event) {
      if (event.target.tagName != 'DIV' && event.target.tagName != 'SPAN') return
      this.isActive = !this.isActive
    }
  }
}
</script>
